"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Skeleton_1 = __importDefault(require("../Skeleton/Skeleton"));
var CardSkeleton = function (_a) {
    var className = _a.className;
    var formatedClass = className
        ? className.split('_').join('-').toLowerCase()
        : '';
    var customClass = className
        ? formatedClass === 'search'
            ? 'search'
            : formatedClass
        : '';
    return (react_1.default.createElement("div", { className: "card-skeleton post-card " + customClass },
        react_1.default.createElement("div", { className: "thumb-container" },
            react_1.default.createElement(Skeleton_1.default, null)),
        react_1.default.createElement("div", { className: "content" },
            react_1.default.createElement(Skeleton_1.default, { width: "40%" }),
            react_1.default.createElement(Skeleton_1.default, { width: "90%" }),
            react_1.default.createElement(Skeleton_1.default, { width: "70%" }))));
};
exports.default = CardSkeleton;
